<template>
  <div class="export-excel">
    <div class="crumbs-navigation">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/main' }">
          <a style="font-weight: normal">
            <!--我的报价单-->
            {{ $t('homePage.myQuotation') }}
          </a>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{name: '/CreatOrderFourth/fourth', query: {projectId: projectId}}">
          <!--导出&分享-->
          {{ $t('exportExcelModule.exportTheShare') }}
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          {{ $t('exportExcelModule.exportExcel') }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="select-option-two">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="grid-content">
            <div class="border-l">
              <span> {{ $t('exportExcelModule.exportFieldScreening') }}</span>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="option-two">
        <el-row :gutter="10">
          <el-col :span="2">
            <div class="grid-content">
              {{ $t('exportExcelModule.exportField') }}
            </div>
          </el-col>
          <!--<el-col :span="22">-->
          <!--<div class="grid-content">-->
          <el-checkbox-group
            v-model="checkListExport"
          >
            <el-col :span="20">
              <el-checkbox
                v-for="item in checkListField"
                :label="item.typeValue"
                :key="item.typeKey"
                :disabled="(item.typeKey === 'showProductName' ||
                  item.typeKey === 'showProductDesc')||
                  (mergeFlag === '2' && item.typeKey === 'showProductNotes')||
                  (mergeFlag === '2' && item.typeKey === 'showOrder')||
                  (mergeFlag !== '3' && item.typeKey ==='showProductSeries')||
                  (mergeFlag !== '3' && item.typeKey ==='showSingleSetPrice')||
                  (mergeFlag !== '3' && item.typeKey ==='showSingleSetPriceDiscount')"
              >
                {{ item.typeValueEn }}
              </el-checkbox>
            </el-col>
          </el-checkbox-group>
          <!--</div>-->
          <!--</el-col>-->
        </el-row>
      </div>
      <div class="option-two">
        <el-row :gutter="10">
          <el-col :span="2">
            <div class="grid-content">
              {{ $t('exportExcelModule.exportFormat') }}
            </div>
          </el-col>
          <!--<el-col :span="22">-->
          <div class="grid-content-checkbox">
            <el-checkbox-group v-model="checkList">
              <el-col :span="19">
                <el-checkbox
                  v-for="item in checkListFormat"
                  @change="onchageFormat(item.typeValue)"
                  :label="item.typeValue"
                  :key="item.typeKey"
                >
                  {{ item.typeValueEn }}
                </el-checkbox>
              </el-col>
            </el-checkbox-group>
          </div>
          <!--</el-col>-->
        </el-row>
      </div>
    </div>
    <div class="btn-p btn-p-e">
      <el-button type="primary" @click="exportProject">
        {{ $t('exportExcelModule.exportExcel') }}
      </el-button>
    </div>
    <el-dialog width="500px" :visible.sync="dialogFormVisible">
      <span
        v-for="(item, index) in exportRuleErrorMessage"
        style="color: red"
        :key="index"
      >
        {{ item }}
      </span>
      <div style="margin-top: 30px">
        <el-button type="primary" @click="dialogFormVisible = false">确定</el-button>
      </div>
    </el-dialog>
    <LowerShelf ref="mychild" :project-id="projectId" :button-name="buttonName" />
    <!--<a :href="downUrl" ref="adown" target="_blank" />-->
    <a href="javascript:" @click="exportOrderExcel" />
    <!--出口合规风险提示弹窗-->
    <ExportComplianceDialog
      :visible.sync="complianceDialog.visible"
      :mode="complianceDialog.mode"
      :level="complianceDialog.level"
      :conclusion="complianceDialog.conclusion"
      :details="complianceDialog.details"
      @cancel="onComplianceCancel"
      @confirm="onComplianceConfirm"
      @submit-review="onComplianceSubmitReview"
    />
  </div>
</template>

<script>
import api from '../../api';
import LowerShelf from '../components/LowerShelf';
import eventBus from '@/utils/eventBus';
import exportCompliance from '@/utils/exportCompliance';
import {GetAuthToken} from "rj-server-auth-token";
import axios from "axios";
export default {
  name: 'ExportOrder',
  components: { LowerShelf },
  mixins: [exportCompliance],
  data () {
    return {
      dialogFormVisible: false,
      exportRuleErrorMessage: [],
      mergeFlag: '3',
      checkListExport: ['产品型号', '产品描述', '目录单价', '总数量', '目录总价', '产品系列', '产品名称'], // 导出字段默认被选中
      checkListField: [], // 导出字段选项获取
      checkList: ['带配置组小计', '带整单总计', '带服务配置组', '带Excel封面'], // 导出格式默认被选中
      checkListFormat: [], // 导出格式选项获取
      projectId: '',
      buttonName: this.$t('exportExcelModule.continueExport'),
      downUrl: ''
    };
  },
  mounted () {
    eventBus.$on('fatherMethods', () => {
      this.exportOrderExcel();
    });
    this.projectId = this.$route.params.projectId;
    this.exportField();
    this.exportFormat();
  },
  destroyed () {
    eventBus.$off('fatherMethods');
  },
  methods: {
    onchageFormat (row) {
      if (row === '合并（不显示产品明细）') {
        if (this.checkList.indexOf(row) > -1) {
          this.checkList.forEach((item, i) => {
            if (item === '合并（显示产品明细）') {
              this.checkList.splice(i, 1);
            }
          });
          this.checkListExport.forEach((item, i) => {
            if (item === '特殊说明') {
              this.checkListExport.splice(i, 1);
            }
          });
          this.checkListExport.forEach((item, i) => {
            if (item === '下单属性') {
              this.checkListExport.splice(i, 1);
            }
          });
          this.checkListExport.forEach((item, i) => {
            if (item === '产品系列') {
              this.checkListExport.splice(i, 1);
            }
          });
          this.checkListExport.forEach((item, i) => {
            if (item === '单套目录价') {
              this.checkListExport.splice(i, 1);
            }
          });
          this.checkListExport.forEach((item, i) => {
            if (item === '单套价格') {
              this.checkListExport.splice(i, 1);
            }
          });
          this.mergeFlag = '2';
        } else {
          this.mergeFlag = '1';
        }
      } else if (row === '合并（显示产品明细）') {
        if (this.checkList.indexOf(row) > -1) {
          this.checkList.forEach((item, i) => {
            if (item === '合并（不显示产品明细）') {
              this.checkList.splice(i, 1);
            }
          });
        }
        this.checkListExport.forEach((item, i) => {
          if (item === '产品系列') {
            this.checkListExport.splice(i, 1);
          }
        });
        this.checkListExport.forEach((item, i) => {
          if (item === '单套目录价') {
            this.checkListExport.splice(i, 1);
          }
        });
        this.checkListExport.forEach((item, i) => {
          if (item === '单套价格') {
            this.checkListExport.splice(i, 1);
          }
        });
        this.mergeFlag = '1';
      }
      if (this.checkList.indexOf('合并（不显示产品明细）') === -1 && this.checkList.indexOf('合并（显示产品明细）') === -1) {
        this.mergeFlag = '3';
      }
    },
    exportProject () {
      // 导出前先做出口合规检测，通过后继续原有导出确认流程
      this.runExportCompliance(this.projectId, () => {
        this.$refs.mychild.shareProject();
      });
    },
    exportOrderExcel () {
      this.$refs.mychild.cancelWind();
      let arrays = [];
      let arraysType = [];
      let checkchoose = { 'projectId': this.projectId };
      // 合并被选中的checkbox为一个数组
      arrays = [...this.checkListExport, ...this.checkList];
      // 合并所有的checkbox选项
      arraysType = [...this.checkListField, ...this.checkListFormat];
      arraysType.forEach((item) => {
        arrays.forEach((items) => {
          if (items === item.typeValue) {
            // 被选中的赋值为true
            checkchoose[item.typeKey] = true;
          } else {
            // 没有被选中的赋值为false
            if (checkchoose.hasOwnProperty(item.typeKey) === false) {
              checkchoose[item.typeKey] = false;
            }
          }
        });
      });
      let params = '';
      for (let key in checkchoose) {
        params += (key + '=' + checkchoose[key] + '&');
      }
      params += ('radio=' + this.radio);
      // 携带本次检测标识：服务端做检测-动作绑定校验（检测通过后由混入层回传）
      params += ('&detectionId=' + encodeURIComponent(this.complianceDetectionId || ''));
      axios({
        baseURL: `${window._env_.VUE_APP_APIBASEURL}`,
        withCredentials: true, // 是否发送cookie
        headers: {
          sysId: 'ae0eed67701b458c8967b4d34207d011',
          'web-sign-server-auth': GetAuthToken({ sysId: 'ae0eed67701b458c8967b4d34207d011', accessKeySecret: '300F358EEB9E4CE2A2B1D15EE4030C4B' })
        },
        method: 'get',
        url: '/product/export/excel?'+params,
        data: this.lstproductmodel,
        responseType: 'blob'
      }).then((res) => {
         if (res.data.type && res.data.type.indexOf('text/html') > -1) {
            this.dialogFormVisible = true;
            const bloddata = new Blob([res.data], { type: "text/html" });
            const text = new FileReader();
            text.readAsText(bloddata);
            var resultData = [];
            text.onload = function(readRes) {
              resultData.push(readRes.target.result);
            };
            this.exportRuleErrorMessage = resultData;
          } else {
            this.loading = false;
            let filename = res.headers['content-disposition'].split('=')[1];
            let blob = new Blob([res.data]);
            if ('download' in document.createElement('a')) { // 非IE下载
              const elink = document.createElement('a');
              elink.download = decodeURIComponent(filename);
              elink.style.display = 'none';
              elink.href = URL.createObjectURL(blob);
              elink.target = '_blank';
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else { // IE10+下载
              navigator.msSaveBlob(blob);
            }
          }
      });
      this.$nextTick(() => {
        this.loading = true;
      });
    },
    exportField () {
      let params = {
        params: {
          businessType: 'ExportField'
        }
      };
      api.basicsConfigController(params).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.checkListField = json.data.list;
          if (json.data.defaultConfig != null) {
            this.checkListExport = json.data.defaultConfig.exportFields.split(',');
          }
        }
      });
    },
    exportFormat () {
      let params = {
        params: {
          businessType: 'ExportFormat'
        }
      };
      api.basicsConfigController(params).then((res) => {
        let json = res.data;
        if (json.data.defaultConfig !== null && json.data.defaultConfig.exportFormats.indexOf('合并（不显示产品明细）') > -1) {
          this.mergeFlag = '2';
        } else if (json.data.defaultConfig !== null && json.data.defaultConfig.exportFormats.indexOf('合并（显示产品明细）') > -1) {
          this.mergeFlag = '1';
        } else {
          this.mergeFlag = '3';
        }
        if (json.status === '200') {
          this.checkListFormat = json.data.list;
          if (json.data.defaultConfig !== null) {
            this.checkList = json.data.defaultConfig.exportFormats.split(',');
          }
        }
      });
    }
  }

};
</script>

<style lang="scss">
  .select-back .btn-p{
    margin-top: 1rem;
    float: left;
    margin-right:4rem;
  }
.el-checkbox__label {
    display: inline-grid;
    width:200px;
    white-space: pre-line;
    word-wrap: break-word;
    line-height: 20px;
  }
  .select-back .btn-p  .el-button--primary {
    color: #fff;
    background-color: #36BAE2!important;
    border-color: #36BAE2!important;
    width:16rem;
    height: 3.6rem;
    line-height: 0;
    margin-left: 0;
  }

  .select-back .btn-p .el-button--primary:hover {
    color: #fff;
    background-color: #60c8e8!important;
    border-color: #60c8e8!important;
  }

  .select-option-two{
    margin-top: 3.8rem;
    text-align: left;
  }

  .select-option-two .border-l{
    border-left:4px solid #36BAE2;
    padding-left: 2rem;
    height: 2rem;
    line-height: 2rem;
  }

  .select-option-two .option-two{
    margin-top: 2rem;
  }

  .el-button--primary:hover {
    color: #fff;
    background-color: #60c8e8!important;
    border-color: #60c8e8!important;
  }

  .export-excel .btn-p-e{
    margin-top: 3rem;
  }

  .export-excel .crumbs-navigation{
    padding-top: 15px;
  }

  .crumbs-navigation .el-breadcrumb__inner a {
    color: #36bade!important;
  }

  .el-breadcrumb__inner a, .el-breadcrumb__inner.is-link{
    font-weight: normal;
  }

  //.el-checkbox+.el-checkbox {
  //  margin-left: 0px;
  //}

  .el-checkbox{
    margin-left: 30px !important;
    margin-bottom: 20px;
    width: 155px;
  }
  @media screen and (max-width: 1334px){
    .export-excel{
      width: 1294px;
    }
    .select-back .btn-p .el-button--primary{
      height: 3.2rem;
    }

    .btn-p .el-button--primary{
      height: 3.2rem;
    }
  }

  @media screen and (max-width: 1366px){
    .export-excel .select-back .btn-p .el-button--primary{
      height: 3rem;
    }

    .export-excel .select-back .btn-p {
      margin-top: 1rem;
    }

    .export-excel .select-option-two{
      margin-top: 2rem;
    }

    .export-excel .btn-p{
      margin-top: 4rem;
    }
    .select-option-two .option-two {
      margin-top: 1rem;
    }
  }
</style>